import { WebPlugin } from '@capacitor/core';
export class ChottuLinkIonicSDKWeb extends WebPlugin {
    async initialize(options) {
        console.log('API Key -> ', options.apiKey);
        throw this.unimplemented('Not implemented on web.');
    }
    async createDynamicLink(options) {
        console.log('Builder -> ', options.builder);
        throw this.unimplemented(`createDynamicLink method in not available in the browser.`);
    }
    async getAppLinkDataFromUrl(options) {
        console.log('Short URL -> ', options.shortURL);
        throw this.unimplemented(`getAppLinkDataFromUrl method in not available in the browser.`);
    }
}
//# sourceMappingURL=web.js.map